import Crm from "@/modules/crm/service/Crm.ts";
import Core from "@/modules/core/service/Core";

const state = {
    total  : 0,
    top    : [],
    journal: [],
    entry  : null,
    filter : {
        deleted: false,
        phonecalls: true,
        comments: true,
        reminder: true,
        documents: false,
        mails: false
    }
}

const mutations = {
    updateReminder (state, payload) {
        state.top   = payload;
        state.total = payload.length
    },

    updateReminderTotal (state, payload) {
        state.total = payload.count;
    },

    updateJournal (state, payload) {
        state.journal = payload;
    },

    updateEntry (state, payload) {
        state.entry = payload;
    },

    updateFilter (state, payload) {
        state.filter = payload;
    },
}

const actions = {
    initCrmFilter ( { commit }) {
        return Core.method.get(Crm.url.filter).then(data => {
            commit ('updateFilter', data);
        });
    },

    setFilterByUser ( { commit }, filter) {
        return Core.method.put(Crm.url.filter, filter).then (() => {
            commit ('updateFilter', filter);
        })
    },

    getReminderByUser ( { commit }) {
        return Core.method.get(Crm.url.top).then(data => {
            commit ('updateReminder', data);
        })
    },

    getTotalReminderByUser ( { commit } ) {
        return Core.method.get(Crm.url.total).then(data => {
            commit ('updateReminderTotal', data);
        })
    },

    findJournalByIncident ( { commit }, filter ) {
        const url = Crm.url.journal + filter.incidentId + "?ignoredeleted=" + filter.ignoreDeleted;
        return Core.method.get(url).then(data => {
            commit ('updateJournal', data);
        })
    },

    findJournalById ( { commit }, entry ) {
        const url = Crm.url.entry + entry.id;
        return Core.method.get(url).then(data => {
            commit ('updateEntry', data);
        })
    },
}

const getters = {
    top: state => {
        return state.top;
    },

    total: state => {
        return state.total;
    },

    journal: state => {
        return state.journal;
    },

    entry: state => {
        return state.entry;
    },

    crmFilter: state => {
        return state.filter;
    },
}

const crmModule = {
    state,
    mutations,
    actions,
    getters
}

export default crmModule